import React, { useState, useEffect, useRef, useContext } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import Button from "components/CustomButtons/Button.js";
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import AlertDialog from '../components/AlertDialog';
import { FirebaseContext, api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { withFallbackTranslations } from 'common/src/other/fallbackTranslations';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import C2Dialog, { C2PrimaryButton, C2SecondaryButton } from '../components/C2Dialog';
import { c2TextFieldSx } from '../components/conecta2ModalStyles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Tooltip,
  Paper,
  Box,
  Stack,
  ButtonBase,
  Divider,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Link as RouterLink } from 'react-router-dom';
import { colors } from '../components/Theme/WebTheme';
import { MAIN_COLOR, FONT_FAMILY, SECONDORY_COLOR } from "../common/sharedFunctions";

const FONT = "'Outfit', 'Poppins', sans-serif";
const fieldSx = {
  mb: 1.75,
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    fontFamily: FONT,
    backgroundColor: '#FBFAFE',
    '& fieldset': { borderColor: '#D7CFEB' },
    '&:hover fieldset': { borderColor: '#B8A9E0' },
    '&.Mui-focused fieldset': { borderColor: '#6411ED', borderWidth: 2 },
  },
  '& .MuiInputLabel-root': {
    fontFamily: FONT,
    color: '#766293',
  },
  '& .MuiInputLabel-root.Mui-focused': { color: '#6411ED' },
  '& .MuiInputBase-input': { fontFamily: FONT, color: '#1A0F3B' },
};

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
      fontFamily: FONT_FAMILY,
    },
  },
  typography: {
    fontFamily: FONT_FAMILY,
  },
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    width: 192,
    height: 192,
  },
  container: {
    zIndex: "12",
    backgroundColor: colors.Header,
    alignContent: 'center',
    borderRadius: "19px",
    padding: '20px',
    width: '70%',
  },
  container1: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.Header_Text,
    borderRadius: "19px",
    padding: '30px',
    width: '100%',
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  title: {
    color: colors.Header_Text,
    textAlign: 'center',
    backgroundColor: colors.Header,
    width: "9rem",
    position: "absolute",
    top: 0,
    paddingBottom: 5,
    borderBottomRightRadius: "15px",
    borderBottomLeftRadius: "15px",
    fontFamily: FONT_FAMILY,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
    backgroundColor: colors.Header,
    alignContent: 'center',
    borderRadius: "19px",
    padding: '10px',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  rootRtl: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  rootRtl3: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  rootRtl_1: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 33,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  submit2: {
    marginLeft: 75,
    top: -40,
    margin: theme.spacing(3, 0, 2),
    backgroundColor: colors.SUB_2,
  },
  icon: {
    backgroundColor: colors.RED,
    width: 30,
    height: 30,
  },
  buttonStyle: {
    margin: 0,
    width: '100%',
    height: 40,
    borderRadius: "30px",
    backgroundColor: MAIN_COLOR,
    marginTop: '25px',
    color: colors.WHITE,
    fontWeight: "bold",
    fontSize: "16px",
    fontFamily: FONT_FAMILY,
  },
  textField: {
    "& label": {
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  selectField: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: MAIN_COLOR,
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  menuItem: {
    fontFamily: FONT_FAMILY,
  },
}));



const MyProfile = () => {
  const { authRef, RecaptchaVerifier, phoneProvider, updatePhoneNumber, mobileAuthCredential } = useContext(FirebaseContext);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    updateProfile,
    updateWebProfileImage,
    updateProfileWithEmail,
    checkUserExists,
    requestMobileOtp,
    updateAuthMobile
  } = api;
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const languagedata = useSelector(state => state.languagedata);
  const [langSelection, setLangSelection] = useState(0);
  const [multiLanguage, setMultiLanguage] = useState();
  const fileInputRef = useRef();
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const settings = useSelector(state => state.settingsdata.settings);


  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    usertype: '',
    verifyId: ''
  });

  const [otp, setOtp] = useState("");
  const [otpCalled, setOtpCalled] = useState(false);
  const [updateCalled, setUpdateCalled] = useState(false);
  const [verificationId, setVerificationId] = useState(null);
  const [referralShareOpen, setReferralShareOpen] = useState(false);

  useEffect(() => {
    if (languagedata.langlist) {
      let arr = Object.keys(languagedata.langlist);
      for (let i = 0; i < arr.length; i++) {
        if (auth.profile && auth.profile.lang && auth.profile.lang.langLocale && auth.profile.lang.langLocale === languagedata.langlist[arr[i]].langLocale) {
          setLangSelection(i);
        }
      }
      setMultiLanguage(languagedata.langlist);
    }
  }, [languagedata.langlist, auth.profile, setMultiLanguage, setLangSelection]);

  useEffect(() => {
    if (auth.profile && auth.profile.uid) {
      setData({
        firstName: auth.profile.firstName,
        lastName: auth.profile.lastName,
        email: auth.profile.email,
        mobile: auth.profile.mobile,
        usertype: auth.profile.usertype,
        profile_image: auth.profile.profile_image ? auth.profile.profile_image : '',
        verifyId: auth.profile.verifyId ? auth.profile.verifyId : ''
      });
      if (updateCalled) {
        setLoading(false);
        setCommonAlert({ open: true, msg: t('profile_updated') });
        setUpdateCalled(false);
      }
    }

  }, [auth.profile, t, updateCalled]);

  const updateData = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  }

  const completeSubmit = () => {
    setUpdateCalled(true);
    let arr = Object.keys(languagedata.langlist);
    localStorage.setItem('lang', JSON.stringify({langLocale: multiLanguage[arr[langSelection]].langLocale, dateLocale: multiLanguage[arr[langSelection]].dateLocale}));

    dispatch(updateProfile({
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      verifyId: data.verifyId,
      lang: { langLocale: multiLanguage[arr[langSelection]].langLocale, dateLocale: multiLanguage[arr[langSelection]].dateLocale }
    }));

    if (selectedImage) {
      updateWebProfileImage(selectedImage);
    }

    const lang = multiLanguage[arr[langSelection]];
    i18n.addResourceBundle(lang.langLocale, 'translations', withFallbackTranslations(lang.langLocale, lang.keyValuePairs));
    i18n.changeLanguage(lang.langLocale);
    moment.locale(lang.dateLocale);
    setSelectedImage(null);
    setCommonAlert({ open: true, msg: t('profile_updated') });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (data.email !== auth.profile.email && data.mobile !== auth.profile.mobile) {
      setCommonAlert({ open: true, msg: t('update_any') })
    } else {
      if (data.firstName && data.firstName.length > 0 && data.lastName && data.lastName.length > 0) {
        if (data.email !== auth.profile.email) {
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (re.test(data.email)) {
            setLoading(true);
            checkUserExists({ email: data.email }).then((res) => {
              if (res.users && res.users.length > 0) {
                setLoading(false);
                alert(t('user_exists'));
              }
              else if (res.error) {
                setLoading(false);
                alert(t('email_or_mobile_issue'));
              } else {
                data['uid'] = auth.profile.uid;
                dispatch(updateProfileWithEmail(data));
                setLoading(false);
                setCommonAlert({ open: true, msg: t('profile_updated') });
              }
            });
          } else {
            setCommonAlert({ open: true, msg: t('proper_email') })
          }
        } else if (data.mobile !== auth.profile.mobile) {
          const mobileNum = String(data.mobile || '').replace(/[\s-]+/g, '');
          if (!mobileNum) {
            setCommonAlert({ open: true, msg: t('mobile_no_blank_error') });
          } else if (!/^\+\d{8,15}$/.test(mobileNum)) {
            setCommonAlert({ open: true, msg: 'Escribe el número en formato internacional, por ejemplo +573001234567.' });
          } else {
            setData({ ...data, mobile: mobileNum });
            setLoading(true);
            checkUserExists({ mobile: mobileNum }).then(async (res) => {
              if (res.users && res.users.length > 0) {
                setLoading(false);
                setCommonAlert({ open: true, msg: t('user_exists') });
              }
              else if (res.error) {
                setLoading(false);
                setCommonAlert({ open: true, msg: t('email_or_mobile_issue') });
              } else if (settings.customMobileOTP) {
                const otpRes = await dispatch(requestMobileOtp(mobileNum));
                setLoading(false);
                if (otpRes && otpRes.success) {
                  setOtp('');
                  setOtpCalled(true);
                } else {
                  setCommonAlert({ open: true, msg: (otpRes && otpRes.error) || t('email_or_mobile_issue') });
                }
              } else {
                try {
                  resetRecaptcha();
                  window.recaptchaVerifier = new RecaptchaVerifier(authRef(), 'sign-in-button', { size: 'invisible' });
                  const id = await phoneProvider.verifyPhoneNumber(mobileNum, window.recaptchaVerifier);
                  setVerificationId(id);
                  setOtp('');
                  setOtpCalled(true);
                } catch (error) {
                  resetRecaptcha();
                  setCommonAlert({ open: true, msg: phoneAuthErrorMessage(error) });
                } finally {
                  setLoading(false);
                }
              }
            });
          }
        } else {
          setLoading(true);
          completeSubmit();
        }
      } else {
        setCommonAlert({ open: true, msg: t('no_details_error') })
      }
    }
  }

  const updateOtp = (e) => {
    setOtp(e.target.value.replace(/\D/g, '').slice(0, 6));
  }

  const resetRecaptcha = () => {
    if (window.recaptchaVerifier) {
      try {
        window.recaptchaVerifier.clear();
      } catch (e) {
        // already cleared
      }
    }
    window.recaptchaVerifier = null;
  };

  const phoneAuthErrorMessage = (error) => {
    switch (error && error.code) {
      case 'auth/invalid-phone-number':
        return 'El número no es válido. Usa el formato internacional, por ejemplo +573001234567.';
      case 'auth/too-many-requests':
        return 'Demasiados intentos. Espera unos minutos antes de pedir otro código.';
      case 'auth/credential-already-in-use':
      case 'auth/account-exists-with-different-credential':
        return t('user_exists');
      case 'auth/code-expired':
        return 'El código venció. Solicita uno nuevo.';
      case 'auth/requires-recent-login':
        return 'Por seguridad, cierra sesión y vuelve a entrar antes de cambiar tu número.';
      case 'auth/invalid-verification-code':
        return t('otp_validate_error');
      default:
        return t('email_or_mobile_issue');
    }
  };

  const handleVerify = async () => {
    if (!(otp && otp.length === 6 && !isNaN(otp))) {
      setCommonAlert({ open: true, msg: t('otp_validate_error') });
      return;
    }
    setLoading(true);
    if (settings.customMobileOTP) {
      const res = await updateAuthMobile(data.mobile, otp);
      if (res.success) {
        setOtpCalled(false);
        setOtp('');
        completeSubmit();
      } else {
        setOtp('');
        setLoading(false);
        setCommonAlert({ open: true, msg: res.error === 'Error updating user' ? t('user_exists') : t('otp_validate_error') });
      }
      return;
    }
    if (!verificationId) {
      setLoading(false);
      handleClose();
      setCommonAlert({ open: true, msg: t('otp_validate_error') });
      return;
    }
    try {
      const credential = mobileAuthCredential(verificationId, otp);
      await updatePhoneNumber(authRef().currentUser, credential);
      setOtpCalled(false);
      setOtp('');
      setVerificationId(null);
      resetRecaptcha();
      completeSubmit();
    } catch (error) {
      setOtp('');
      setLoading(false);
      const code = error && error.code;
      if (code !== 'auth/invalid-verification-code') {
        handleClose();
      }
      setCommonAlert({ open: true, msg: phoneAuthErrorMessage(error) });
    }
  }

  const handleClose = () => {
    setOtp('');
    setOtpCalled(false);
    setVerificationId(null);
    resetRecaptcha();
    setData((prev) => ({ ...prev, mobile: auth.profile.mobile }));
  }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleLanguageSelect = (event) => {
    setLangSelection(event.target.value);
  };

  const referralId = auth.profile?.referralId;
  const companyBase = settings?.CompanyWebsite
    ? String(settings.CompanyWebsite).replace(/\/$/, '')
    : (typeof window !== 'undefined' ? window.location.origin : '');
  const referralFullLink =
    referralId && companyBase ? `${companyBase}/login/${referralId}` : '';

  /** Texto completo para compartir (enlace incluido en el cuerpo; evita fallos en Windows al mezclar url+text) */
  const buildReferralShareText = () => {
    if (!referralFullLink || !referralId) return '';
    const base =
      settings?.bonus > 0 && settings?.code
        ? t('share_msg') +
          settings.code +
          ' ' +
          settings.bonus +
          '.\n' +
          t('master_code_colon') +
          referralId +
          '\n' +
          t('app_link') +
          referralFullLink
        : t('share_msg') +
          '.\n' +
          t('master_code_colon') +
          referralId +
          '\n' +
          t('app_link') +
          referralFullLink;
    return base;
  };

  const copyReferralLink = async () => {
    if (!referralFullLink) return;
    try {
      await navigator.clipboard.writeText(referralFullLink);
      setCommonAlert({
        open: true,
        msg: t('link_copied', { defaultValue: 'Enlace copiado al portapapeles' }),
      });
    } catch (err) {
      setCommonAlert({ open: true, msg: t('otp_validate_error') });
    }
  };

  const copyReferralShareText = async () => {
    const text = buildReferralShareText();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCommonAlert({
        open: true,
        msg: t('link_copied', { defaultValue: 'Mensaje copiado al portapapeles' }),
      });
    } catch (err) {
      setCommonAlert({ open: true, msg: t('otp_validate_error') });
    }
  };

  /** Panel nativo (Windows suele mostrar Outlook, etc.; no WhatsApp web) */
  const tryNativeSystemShare = async () => {
    if (!referralFullLink || !referralId) return;
    const text = buildReferralShareText();
    const title = t('profile_referral_link_section', {
      defaultValue: 'Tu enlace de referido',
    });

    try {
      if (typeof navigator !== 'undefined' && navigator.share) {
        const payload = { title, text };
        if (navigator.canShare && !navigator.canShare(payload)) {
          await copyReferralShareText();
          return;
        }
        await navigator.share(payload);
        return;
      }
      await copyReferralShareText();
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      await copyReferralShareText();
    }
  };

  const openExternalShare = (url) => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const getSocialShareUrls = () => {
    const text = buildReferralShareText();
    const url = referralFullLink;
    if (!text || !url) return null;
    return {
      whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      email: `mailto:?subject=${encodeURIComponent(t('profile_referral_link_section', { defaultValue: 'Tu enlace de referido' }))}&body=${encodeURIComponent(text)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      sms: `sms:?body=${encodeURIComponent(text)}`,
    };
  };

  const profileImageChange = async (e) => {
    setSelectedImage(e.target.files[0]);
  }

  const adorn = (Icon) => (
    <InputAdornment position="start">
      <Icon sx={{ color: '#766293', fontSize: 22 }} />
    </InputAdornment>
  );

  return (
    auth.loading ? <CircularLoading /> :
      <Box sx={{ px: { xs: 0.5, sm: 1 }, pb: 3, maxWidth: 1100, mx: 'auto' }}>
        <div id="sign-in-button" />
        <CssBaseline />

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 1.5,
            mb: 2.5,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: FONT,
                fontWeight: 800,
                fontSize: { xs: '1.6rem', sm: '2rem' },
                color: '#1A0F3B',
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                lineHeight: 1.1,
              }}
            >
              {t('profile') || t('profile_title') || 'PERFIL'}
            </Typography>
            <Typography
              sx={{
                mt: 0.75,
                fontFamily: FONT,
                fontSize: '0.92rem',
                color: '#766293',
                maxWidth: 480,
                lineHeight: 1.4,
              }}
            >
              Completa tu información para una mejor experiencia en Conecta2.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              color: '#766293',
              fontFamily: FONT,
              fontSize: '0.8rem',
              flexShrink: 0,
            }}
          >
            <HomeOutlinedIcon sx={{ fontSize: 16, color: '#6411ED' }} />
            <Box
              component={RouterLink}
              to="/"
              sx={{ color: '#766293', textDecoration: 'none', '&:hover': { color: '#6411ED' } }}
            >
              Inicio
            </Box>
            <Typography component="span" sx={{ color: '#B8A9E0', mx: 0.25 }}>{'>'}</Typography>
            <Typography component="span" sx={{ color: '#1A0F3B', fontWeight: 600 }}>
              Perfil
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={2.5} alignItems="stretch">
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                height: '100%',
                minHeight: { xs: 280, md: 520 },
                borderRadius: '18px',
                overflow: 'hidden',
                position: 'relative',
                background: 'linear-gradient(165deg, #2C195B 0%, #1A0F3B 55%, #221448 100%)',
                boxShadow: '0 12px 32px rgba(26,15,59,0.22)',
                p: { xs: 2.5, sm: 3 },
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage: `url(${require('../assets/img/driver_vertical.jpg')})`,
                  backgroundSize: 'cover',
                  backgroundPosition: '85% 70%',
                  opacity: 0.35,
                  pointerEvents: 'none',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'linear-gradient(180deg, rgba(26,15,59,0.55) 0%, rgba(26,15,59,0.75) 45%, rgba(26,15,59,0.92) 100%)',
                  pointerEvents: 'none',
                }}
              />
              <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontWeight: 800,
                    fontSize: { xs: '1.35rem', sm: '1.55rem' },
                    color: '#FBFAFE',
                    lineHeight: 1.2,
                    letterSpacing: '0.03em',
                    textTransform: 'uppercase',
                    mb: 1,
                  }}
                >
                  TU INFORMACIÓN NOS CONECTA
                </Typography>
                <Box
                  sx={{
                    width: 42,
                    height: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(90deg, #6411ED, #7628FF)',
                    mb: 1.5,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontSize: '0.9rem',
                    color: 'rgba(251,250,254,0.88)',
                    lineHeight: 1.5,
                    mb: 3,
                  }}
                >
                  Mantén tus datos actualizados para disfrutar de todos los beneficios de{' '}
                  <Box component="strong" sx={{ fontWeight: 700 }}>Conecta2</Box>.
                </Typography>

                {[
                  { icon: ShieldOutlinedIcon, label: 'Más seguridad' },
                  { icon: BoltOutlinedIcon, label: 'Mejor experiencia' },
                  { icon: GroupsOutlinedIcon, label: 'Más oportunidades' },
                ].map((item) => (
                  <Box
                    key={item.label}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.75 }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(100,17,237,0.55)',
                        border: '1px solid rgba(118,40,255,0.55)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <item.icon sx={{ color: '#FBFAFE', fontSize: 20 }} />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: FONT,
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        color: '#FBFAFE',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            <Box
              sx={{
                height: '100%',
                backgroundColor: '#FBFAFE',
                borderRadius: '18px',
                border: '1px solid #D7CFEB',
                boxShadow: '0 8px 24px rgba(26,15,59,0.06)',
                p: { xs: 2, sm: 3 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                <Box
                  onClick={() => fileInputRef.current.click()}
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: '50%',
                    backgroundColor: '#EBE7FB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    flexShrink: 0,
                    border: '1px solid #D7CFEB',
                  }}
                >
                  {selectedImage ? (
                    <img
                      src={URL.createObjectURL(selectedImage)}
                      alt="Profile"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : data.profile_image ? (
                    <img
                      src={data.profile_image}
                      alt="Profile"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <PersonOutlineIcon sx={{ color: '#6411ED', fontSize: 28 }} />
                  )}
                </Box>
                <input
                  onChange={(event) => profileImageChange(event)}
                  multiple={false}
                  ref={fileInputRef}
                  type="file"
                  hidden
                />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 700,
                      fontSize: '1.15rem',
                      color: '#1A0F3B',
                    }}
                  >
                    Información de usuario
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontSize: '0.85rem',
                      color: '#766293',
                      mt: 0.25,
                    }}
                  >
                    Completa tus datos para mantener tu cuenta actualizada
                  </Typography>
                </Box>
              </Box>

              <form onSubmit={handleSubmit} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
                <TextField
                  className={isRTL === 'rtl' ? classes.rootRtl : classes.textField}
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  id="firstName"
                  label={t('firstname') || 'Nombre'}
                  name="firstName"
                  autoComplete="firstName"
                  onChange={updateData}
                  value={data.firstName}
                  autoFocus
                  sx={fieldSx}
                  InputProps={{ startAdornment: adorn(PersonOutlineIcon) }}
                />
                <TextField
                  className={isRTL === 'rtl' ? classes.rootRtl_1 : classes.textField}
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  id="lastName"
                  label={t('lastname') || 'Apellido'}
                  name="lastName"
                  autoComplete="lastName"
                  onChange={updateData}
                  value={data.lastName}
                  sx={fieldSx}
                  InputProps={{ startAdornment: adorn(PersonOutlineIcon) }}
                />
                <TextField
                  className={isRTL === 'rtl' ? classes.rootRtl : classes.textField}
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  id="email"
                  label={t('email') || 'Correo electrónico'}
                  name="email"
                  autoComplete="email"
                  onChange={updateData}
                  value={data.email}
                  sx={fieldSx}
                  InputProps={{ startAdornment: adorn(EmailOutlinedIcon) }}
                />
                <TextField
                  className={isRTL === 'rtl' ? classes.rootRtl_1 : classes.textField}
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  id="mobile"
                  label={t('phone') || 'Teléfono'}
                  name="mobile"
                  autoComplete="mobile"
                  onChange={updateData}
                  value={data.mobile}
                  sx={{
                    ...fieldSx,
                    ...(isRTL === 'rtl' ? { '& .MuiInputBase-input': { textAlign: 'end' } } : {}),
                  }}
                  dir="ltr"
                  InputProps={{ startAdornment: adorn(PhoneOutlinedIcon) }}
                />
                <TextField
                  className={isRTL === 'rtl' ? classes.rootRtl : classes.textField}
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  id="usertype"
                  label={t('usertype') || 'Tipo de usuario'}
                  name="usertype"
                  value={data.usertype}
                  disabled
                  sx={fieldSx}
                  InputProps={{
                    startAdornment: adorn(DirectionsCarOutlinedIcon),
                  }}
                />
                {((settings && settings.imageIdApproval) || (data && data.verifyId)) &&
                auth.profile.usertype !== 'admin' ? (
                  <TextField
                    className={isRTL === 'rtl' ? classes.rootRtl : classes.textField}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    id="verifyId"
                    label={t('verify_id') || 'Número Documento ID/Cédula'}
                    name="verifyId"
                    value={data.verifyId}
                    onChange={updateData}
                    sx={fieldSx}
                    InputProps={{ startAdornment: adorn(BadgeOutlinedIcon) }}
                  />
                ) : null}

                {multiLanguage && multiLanguage.length > 1 ? (
                  <Select
                    id="language-select"
                    className={classes.selectField}
                    value={langSelection}
                    variant="outlined"
                    onChange={handleLanguageSelect}
                    fullWidth
                    sx={{
                      mb: 2,
                      borderRadius: '12px',
                      backgroundColor: '#FBFAFE',
                      fontFamily: FONT,
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D7CFEB' },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6411ED' },
                    }}
                  >
                    {Object.keys(multiLanguage).map((key, index) => (
                      <MenuItem
                        key={key}
                        value={index}
                        style={{ justifyContent: isRTL === 'rtl' ? 'flex-end' : 'flex-start' }}
                      >
                        <Typography style={{ fontFamily: FONT_FAMILY }}>
                          {multiLanguage[key].langName}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                ) : null}

                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                    <CircularProgress sx={{ color: '#6411ED' }} />
                  </Box>
                ) : (
                  <Button
                    type="submit"
                    onClick={handleSubmit}
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 1,
                      py: 1.4,
                      borderRadius: '14px',
                      textTransform: 'none',
                      fontFamily: FONT,
                      fontWeight: 700,
                      fontSize: '1rem',
                      background: 'linear-gradient(90deg, #6411ED 0%, #7628FF 100%)',
                      boxShadow: '0 8px 20px rgba(100,17,237,0.3)',
                      display: 'flex',
                      gap: 1,
                      '&:hover': {
                        background: 'linear-gradient(90deg, #5B0FD9 0%, #6D1FF0 100%)',
                      },
                    }}
                  >
                    Guardar cambios
                    <ChevronRightIcon />
                  </Button>
                )}
              </form>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2.5 }}>
          {auth.profile?.usertype === 'driver' && referralId ? (
            <Paper
              component="section"
              elevation={0}
              sx={{
                width: '100%',
                p: 2.5,
                boxSizing: 'border-box',
                borderRadius: '16px',
                border: '1px solid #D7CFEB',
                backgroundColor: '#FBFAFE',
                boxShadow: '0 8px 24px rgba(26,15,59,0.06)',
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ mb: 1.5, fontWeight: 700, fontFamily: FONT, color: '#6411ED' }}
              >
                {t('profile_referral_link_section', {
                  defaultValue: 'Tu enlace de referido',
                })}
              </Typography>
              <Typography variant="caption" display="block" sx={{ mb: 1.5, opacity: 0.85, fontFamily: FONT, color: '#766293' }}>
                {t('referral_block_hint', {
                  defaultValue: 'Copia el enlace o comparte el mensaje con tu código.',
                })}
              </Typography>
              <TextField
                className={isRTL === 'rtl' ? classes.rootRtl_1 : classes.textField}
                variant="outlined"
                margin="dense"
                fullWidth
                id="referralCode"
                label={t('codigo_master', { defaultValue: 'Código master' })}
                value={referralId}
                InputProps={{ readOnly: true }}
                sx={fieldSx}
              />
              <TextField
                className={isRTL === 'rtl' ? classes.rootRtl : classes.textField}
                variant="outlined"
                margin="dense"
                fullWidth
                id="referralLink"
                label={t('app_link', { defaultValue: 'Enlace de la aplicación' }).replace(/\s*:?\s*$/, '')}
                value={referralFullLink}
                sx={{
                  ...fieldSx,
                  '& .MuiInputBase-input': {
                    wordBreak: 'break-all',
                    textOverflow: 'clip',
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        title={t('copy_link', { defaultValue: 'Copiar enlace' })}
                      >
                        <IconButton
                          edge="end"
                          onClick={copyReferralLink}
                          aria-label={t('copy_link', { defaultValue: 'Copiar enlace' })}
                          size="small"
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{
                  mt: 2,
                  py: 1.2,
                  borderRadius: '14px',
                  textTransform: 'none',
                  fontFamily: FONT,
                  fontWeight: 700,
                  background: 'linear-gradient(90deg, #6411ED 0%, #7628FF 100%)',
                  boxShadow: '0 6px 16px rgba(100,17,237,0.28)',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #5B0FD9 0%, #6D1FF0 100%)',
                  },
                }}
                onClick={() => setReferralShareOpen(true)}
              >
                <ShareIcon style={{ marginRight: 8, fontSize: 20 }} />
                {t('share_referral_link', { defaultValue: 'Compartir enlace' })}
              </Button>

              <Dialog
                open={referralShareOpen}
                onClose={() => setReferralShareOpen(false)}
                fullWidth
                maxWidth="sm"
                scroll="body"
                PaperProps={{
                  elevation: 0,
                  sx: {
                    borderRadius: '16px',
                    overflow: 'hidden',
                    maxWidth: 400,
                    border: '1px solid #D7CFEB',
                    boxShadow: '0 16px 40px rgba(26,15,59,0.18)',
                    backgroundColor: '#FBFAFE',
                  },
                }}
              >
                <Box
                  sx={{
                    background: `linear-gradient(135deg, ${MAIN_COLOR} 0%, #2d0066 55%, #1a003d 100%)`,
                    color: colors.WHITE,
                    px: 2.5,
                    pt: 2,
                    pb: 2,
                  }}
                >
                  <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
                    <Stack spacing={0.75} sx={{ pr: 1, flex: 1 }}>
                      <Typography
                        component="h2"
                        sx={{
                          fontFamily: FONT_FAMILY,
                          fontWeight: 700,
                          fontSize: '1.05rem',
                          lineHeight: 1.3,
                          letterSpacing: '0.01em',
                        }}
                      >
                        {t('share_via_social', {
                          defaultValue: 'Compartir en redes y mensajes',
                        })}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          opacity: 0.9,
                          fontFamily: FONT_FAMILY,
                          fontSize: '0.8125rem',
                          lineHeight: 1.45,
                          fontWeight: 400,
                        }}
                      >
                        {t('share_via_social_hint', {
                          defaultValue:
                            'Elige una red; se abrirá en una nueva pestaña con tu mensaje y enlace.',
                        })}
                      </Typography>
                    </Stack>
                    <IconButton
                      size="small"
                      onClick={() => setReferralShareOpen(false)}
                      aria-label={t('cancel', { defaultValue: 'Cerrar' })}
                      sx={{
                        color: 'rgba(255,255,255,0.92)',
                        mt: -0.5,
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' },
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </Box>

                <DialogContent
                  sx={{
                    pt: 2,
                    pb: 0,
                    px: 2,
                    bgcolor: SECONDORY_COLOR,
                    backgroundImage: `linear-gradient(180deg, ${SECONDORY_COLOR} 0%, ${colors.WHITE} 38%)`,
                  }}
                >
                  <Grid container spacing={1.25}>
                    {(() => {
                      const urls = getSocialShareUrls();
                      if (!urls) return null;
                      const items = [
                        {
                          key: 'wa',
                          label: t('share_whatsapp', { defaultValue: 'WhatsApp' }),
                          iconBg: 'rgba(37, 211, 102, 0.14)',
                          icon: <WhatsAppIcon sx={{ color: '#25D366', fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.whatsapp),
                        },
                        {
                          key: 'fb',
                          label: t('share_facebook', { defaultValue: 'Facebook' }),
                          iconBg: 'rgba(24, 119, 242, 0.12)',
                          icon: <FacebookIcon sx={{ color: '#1877F2', fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.facebook),
                        },
                        {
                          key: 'tw',
                          label: t('share_twitter', { defaultValue: 'X (Twitter)' }),
                          iconBg: 'rgba(15, 20, 25, 0.08)',
                          icon: <TwitterIcon sx={{ color: '#0f1419', fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.twitter),
                        },
                        {
                          key: 'tg',
                          label: t('share_telegram', { defaultValue: 'Telegram' }),
                          iconBg: 'rgba(0, 136, 204, 0.12)',
                          icon: <TelegramIcon sx={{ color: '#0088cc', fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.telegram),
                        },
                        {
                          key: 'li',
                          label: t('share_linkedin', { defaultValue: 'LinkedIn' }),
                          iconBg: 'rgba(10, 102, 194, 0.12)',
                          icon: <LinkedInIcon sx={{ color: '#0A66C2', fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.linkedin),
                        },
                        {
                          key: 'mail',
                          label: t('share_email', { defaultValue: 'Correo' }),
                          iconBg: `${MAIN_COLOR}18`,
                          icon: <EmailIcon sx={{ color: MAIN_COLOR, fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.email),
                        },
                        {
                          key: 'sms',
                          label: t('share_sms', { defaultValue: 'SMS' }),
                          iconBg: `${MAIN_COLOR}14`,
                          icon: <PhoneIphoneIcon sx={{ color: MAIN_COLOR, fontSize: 22 }} />,
                          onClick: () => openExternalShare(urls.sms),
                        },
                      ];
                      return items.map((item) => (
                        <Grid item xs={6} key={item.key}>
                          <ButtonBase
                            focusRipple
                            onClick={() => {
                              item.onClick();
                              setReferralShareOpen(false);
                            }}
                            sx={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.25,
                              p: 1.25,
                              borderRadius: '12px',
                              border: `1px solid ${MAIN_COLOR}1f`,
                              bgcolor: colors.WHITE,
                              textAlign: 'left',
                              transition: 'border-color 0.2s, box-shadow 0.2s, background-color 0.2s',
                              boxShadow: '0 1px 3px rgba(68, 0, 153, 0.06)',
                              '&:hover': {
                                borderColor: `${MAIN_COLOR}66`,
                                bgcolor: `${colors.WHITE}`,
                                boxShadow: `0 4px 14px rgba(68, 0, 153, 0.1)`,
                              },
                            }}
                          >
                            <Box
                              sx={{
                                width: 40,
                                height: 40,
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                bgcolor: item.iconBg,
                              }}
                            >
                              {item.icon}
                            </Box>
                            <Typography
                              sx={{
                                fontFamily: FONT_FAMILY,
                                fontWeight: 600,
                                fontSize: '0.8125rem',
                                color: colors.Header,
                                lineHeight: 1.25,
                                textTransform: 'none',
                              }}
                            >
                              {item.label}
                            </Typography>
                          </ButtonBase>
                        </Grid>
                      ));
                    })()}
                  </Grid>

                  {typeof navigator !== 'undefined' && navigator.share ? (
                    <>
                      <Divider sx={{ my: 2, borderColor: `${MAIN_COLOR}22` }} />
                      <ButtonBase
                        focusRipple
                        onClick={async () => {
                          await tryNativeSystemShare();
                          setReferralShareOpen(false);
                        }}
                        sx={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.25,
                          p: 1.25,
                          mb: 1,
                          borderRadius: '12px',
                          border: `1px dashed ${MAIN_COLOR}55`,
                          bgcolor: `${MAIN_COLOR}08`,
                        }}
                      >
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: `${MAIN_COLOR}18`,
                          }}
                        >
                          <MoreHorizIcon sx={{ color: MAIN_COLOR }} />
                        </Box>
                        <Typography sx={{ fontFamily: FONT_FAMILY, fontWeight: 600, fontSize: '0.8125rem', color: MAIN_COLOR }}>
                          {t('share_more', { defaultValue: 'Más opciones del sistema' })}
                        </Typography>
                      </ButtonBase>
                    </>
                  ) : null}
                </DialogContent>

                <DialogActions
                  sx={{
                    px: 2,
                    py: 1.75,
                    bgcolor: colors.WHITE,
                    borderTop: `1px solid ${MAIN_COLOR}18`,
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    type="button"
                    fullWidth
                    variant="outlined"
                    onClick={() => setReferralShareOpen(false)}
                    sx={{
                      fontFamily: FONT_FAMILY,
                      fontWeight: 700,
                      fontSize: '0.875rem',
                      textTransform: 'none',
                      borderRadius: '30px',
                      py: 1,
                      borderColor: `${MAIN_COLOR}55`,
                      color: MAIN_COLOR,
                      maxWidth: 280,
                      '&:hover': {
                        borderColor: MAIN_COLOR,
                        bgcolor: `${MAIN_COLOR}0d`,
                      },
                    }}
                  >
                    {t('cancel', { defaultValue: 'Cerrar' })}
                  </Button>
                </DialogActions>
              </Dialog>
            </Paper>
          ) : null}
        </Box>

        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
        <C2Dialog
          open={otpCalled}
          onClose={handleClose}
          title={t('otp_here', { defaultValue: 'Ingresa el código OTP' })}
          icon={LockOutlinedIcon}
          actions={
            loading ? (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 1 }}>
                <CircularProgress size={28} sx={{ color: '#6411ED' }} />
              </Box>
            ) : (
              <>
                <C2SecondaryButton onClick={handleClose}>
                  {t('cancel', { defaultValue: 'Cancelar' })}
                </C2SecondaryButton>
                <C2PrimaryButton onClick={handleVerify}>
                  {t('verify_otp', { defaultValue: 'Verificar OTP' })}
                </C2PrimaryButton>
              </>
            )
          }
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label={t('otp', { defaultValue: 'OTP' })}
            fullWidth
            variant="outlined"
            inputProps={{ inputMode: 'numeric', maxLength: 6, autoComplete: 'one-time-code' }}
            helperText={`Te enviamos un código de 6 dígitos al ${data.mobile || ''}`}
            onChange={updateOtp}
            value={otp}
            sx={c2TextFieldSx}
          />
        </C2Dialog>
      </Box>
  );
};

export default MyProfile;
